/***
 * @Authors:
 *      Rahul
 ***/

/*** Imports ***/

/* Style imports */
import './styles.css';

/* Library imports */
import React from "react";
import PropTypes from 'prop-types';
import classNames from 'classnames';


/*** End Imports ***/

const TitleLogo = (props) => {

    let activeClass = null;
    if(props.isActive) {
        activeClass = "active";
    }
    else {
        activeClass = "inActive";
    }

    let boostHeader = null;
    
    boostHeader = classNames({"boost-header" : !props.horizontal},{"horizontal" : props.horizontal})
    return (
        <div className= {boostHeader}>
            <div className="circle">
                <img style={props.imageStyle} src={props.srcIcon} alt="Boost Image"/>
            </div>
            <p style={props.boostHeaderStyle} className={activeClass}>
                {props.titleHeader}
            </p>
        </div>
    );
};

/**
 * all prop types which can be passed to this component
 */
TitleLogo.propTypes = {
    titleHeader: PropTypes.string.isRequired,
    srcIcon: PropTypes.string.isRequired,
    isActive: PropTypes.bool,
    boostHeaderStyle: PropTypes.object,
};

/**
 * Only if default initialization is required
 * Default props value for this component
 */
TitleLogo.defaultProps ={
    boostHeaderStyle : {
        textTransform: "uppercase"
    }
};

export default TitleLogo;



// WEBPACK FOOTER //
// ./src/components/TitleLogo/TitileLogo.js